<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        <template v-if="mode === 'add'">Add checklist template</template>
        <template v-if="mode === 'edit'">Edit checklist template</template>
      </h3>

      <validation-observer ref="checklist-template-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <label for="name">Checklist template name:</label>
              <d-input
                v-model="data.name"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'ChecklistTemplatePopup',
  data () {
    return {
      mode: 'add',
      isVisible: false,
      loading: false,
      data: {
        id: null,
        name: ''
      }
    };
  },
  mounted () {
    this.$bus.$on('show-checklist-template-popup', this.show);
  },
  methods: {
    show (mode = 'add', name = '', id = null) {
      this.mode = mode;
      this.data = { id, name };

      setTimeout(() => {
        this.$refs['checklist-template-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['checklist-template-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let formDataToSend = this.prepareFormData();
      let endpointURL = '/check-list-templates/store';

      if (this.mode === 'edit') {
        endpointURL = '/check-list-templates/update/' + parseInt(this.data.id, 10);
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointURL,
        formData: formDataToSend,
        successTitle: 'Checklist template ' + (this.mode ? 'added' : 'edited'),
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the checklist template. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('checklist-template-list-reload');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        name: this.data.name
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-checklist-template-popup', this.show);
  }
}
</script>
